import {request, serviceUrl} from "@/utils/request";

//保存或者更新自定义页面布局
export function saveOrUpdateCustomLayout(params) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-layout',
    method: 'post',
    data: params
  })
}

//删除或者更新自定义页面布局
export function deleteCustomLayout(id) {
  return request({
    url: serviceUrl.deviceService + '/device/custom-layout',
    method: 'delete',
    params: {id}
  })
}
